import { useTheme } from '@mui/material';
import { useEffect } from 'react';

export const StatusBarStyleUpdater = () => {
  const theme = useTheme();

  useEffect(() => {
    const meta = document.querySelector('meta[name="theme-color"]');

    if (meta) {
      // sync status bar background color with the current theme
      meta.setAttribute('content', theme.palette.custom.OV.sys.background);
    }
  }, [theme.palette.custom.OV.sys.background, theme.palette.mode]);

  return null;
};
